// The "sort order" of a location or department (lower first, empty = alphabetical). Same limit as
// the API (MAX_SORT_ORDER in validators.ts).
export const MAX_SORT_ORDER = 9999

// '' or blanks -> null (no order); a whole number 0..MAX_SORT_ORDER -> that number; anything else
// -> undefined (invalid)
export function parseSortOrder(text: string): number | null | undefined {
  const value = text.trim()
  if (value === '') {
    return null
  }
  if (!/^\d+$/.test(value)) {
    return undefined
  }
  const number = Number(value)
  return number <= MAX_SORT_ORDER ? number : undefined
}
